// Frontend API integration for Sample Images
import { API_BASE_URL } from './tourism';

export class ImageAPI {
  /**
   * Fetch sample image URLs from the backend.
   * These are shared across all itineraries as a central image pool.
   * Returns an array of full image URLs served via /api/images/sample/.
   */
  static async fetchSampleImages(): Promise<string[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/carousel-images`);

      if (!response.ok) {
        console.warn(`Carousel images API returned ${response.status}`);
        return [];
      }

      const data = await response.json();
      return data.carousel_images || [];
    } catch (err) {
      console.warn('Failed to fetch sample images:', err);
      return [];
    }
  }
}
